import $ from 'jquery';
import { commonMiddleware, protectRoute } from '../middleware';
import ReactDOM from 'react-dom';
import React from 'react';
import { CreditsPage } from '~src/components/Credits';
import { trackPageView } from '~src/tracking';
import { initHomeExperience } from '~src/home';
import { initSidebarProfile } from '../../sidebar-profile';

export const removebgRoute = async () => {
  document.title = 'Crediti IA | Giotto';

  await protectRoute();
  await commonMiddleware();

  // Ensure the window is at the top before rendering
  try {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  } catch (e) {
    // no-op
  }

  // Hide app navbars for dashboard layout consistency
  $('#navbar-private').hide();
  $('#navbar-canvas').hide();
  $('.logo').hide();

  // Show Credits route (dashboard layout)
  $('#route-credits').show();

  // Match Products behavior: let the document scroll; keep sidebar sticky
  $('body').removeClass('dashboard dashboard-sidebar-open');

  // Setup responsive sidebar interactions and profile menu
  initHomeExperience();
  initSidebarProfile();

  // Render Credits page
  const domContainer = document.querySelector('#credits-root');
  ReactDOM.render(React.createElement(CreditsPage), domContainer);

  // Pageview tracking
  trackPageView('Credits');
};
